import { useEffect, useState } from "react";
import { api } from "../lib/api";

let cache = null;
export const useJobCategories = () => {
  const [data, setData] = useState(cache || { categories: [], sectors: [] });
  useEffect(() => { if (!cache) api.get("/job-categories").then((r) => { cache = r.data; setData(r.data); }); }, []);
  return data;
};

export const CategorySelect = ({ value, onChange, allLabel, testid, className = "dx-input" }) => {
  const { categories } = useJobCategories();
  return (
    <select className={className} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
      {allLabel && <option value="">{allLabel}</option>}
      {categories.map((g) => (
        <optgroup key={g.group} label={g.group}>
          {g.items.map((c) => <option key={c} value={c}>{c}</option>)}
        </optgroup>
      ))}
    </select>
  );
};

export const SectorSelect = ({ value, onChange, allLabel, testid, className = "dx-input" }) => {
  const { sectors } = useJobCategories();
  return (
    <select className={className} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
      {allLabel && <option value="">{allLabel}</option>}
      {sectors.map((s) => <option key={s} value={s}>{s}</option>)}
    </select>
  );
};
